import React from "react"
import PropTypes from "prop-types"

import styles from "./Grid.module.css"

const gridTypes = {
  tightColumns: "tight columns",
  tightRows: "tight rows",
  rows: "rows",
  cells: "cells",
  lined: "lined",
}

const Grid = props => {
  let gridClass

  switch (props.type) {
    case gridTypes.tightRows:
      gridClass = styles.tightRows
      break
    case gridTypes.rows:
      gridClass = styles.rows
      break
    case gridTypes.tightColumns:
      gridClass = styles.tightColumns
      break
    case gridTypes.cells:
      gridClass = styles.cells
      break
    default:
      gridClass = styles.grid
  }

  return <div className={gridClass}>{props.children}</div>
}

Grid.propTypes = {
  type: PropTypes.oneOf(Object.values(gridTypes)),
}

export default Grid
